
import { useThree } from "@react-three/fiber"
import { forwardRef } from 'react'

// lights 
const Lights = forwardRef((props, ref) => {
  const { viewport } = useThree()

  return (
    <>
      <hemisphereLight
        intensity={Math.PI}
        position={[0, 0, -1]}
        scale={5}
        rotation={[Math.PI / 4, Math.PI / 5, Math.PI / 4]}
        args={[0xffffff, 0xffffff, 1.0]}
        color={0x7095c1}
        groundColor={0xcbc1b2}
      />
      <pointLight
        position={[-1, 1.5, 1.5]}
        decay={0.8}
        intensity={1.5}
        castShadow
      />
    </>
  )
})

export default Lights